<basic-table [tableClass]="getTableClass()"
             [tabs]="prepareTableHeader()"
             (headerCallback)="headerCallbackHandler($event)"
             [rows]="prepareTableBody()"
             [paginationId]="paginationId"
             [isInternal]="getOptionalValue('isInternal')"
             [isCustomer]="getOptionalValue('isCustomer')"
             [skipHeader]="getOptionalValue('skipHeader')"
             [loading]="loading">
</basic-table>
@if (paginationId !== 'vr-details' && paginationId !== 'mm-details' && (loading || rows?.length)) {
  <pagination class="ml-s mr-s" [id]="paginationId" [loading]="loading" (callback)="headerCallbackHandler($event)"></pagination>
}
